export const Bars = ({ title, data, labels = {}, testId, keepOrder = false }) => {
  const entries = keepOrder ? data : Object.entries(data).sort((a, b) => b[1] - a[1]);
  const max = Math.max(1, ...entries.map(([, v]) => v));
  return (
    <section data-testid={testId} className="space-y-3">
      {title && <h2 className="font-display text-base font-semibold">{title}</h2>}
      {entries.length === 0 ? <p className="text-sm text-muted-foreground">Sem dados no período.</p> : (
        <ul className="space-y-2">
          {entries.map(([k, v]) => (
            <li key={k} className="grid grid-cols-[minmax(0,190px)_minmax(40px,1fr)_44px] items-center gap-3 text-sm">
              <span className="truncate" title={labels[k] || k}>{labels[k] || k}</span>
              <span className="h-2.5 rounded-sm bg-zap-line"><span className="block h-full rounded-sm bg-zap-green" style={{ width: `${(v / max) * 100}%` }} /></span>
              <span className="text-right font-semibold tabular-nums">{v}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
